import script from "./DefInformText.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefInformText.vue?vue&type=script&lang=ts&setup=true"

import "./DefInformText.vue?vue&type=style&index=0&id=b4477670&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4477670"]])

export default __exports__